import { useContext } from 'react';
import { PastEventsContextProps } from 'src/modules/alarm-processing/contexts/past-events/types';

import { PastEventsContext } from './../contexts/past-events/provider';

export function usePastEvents(): PastEventsContextProps {
    return useContext(PastEventsContext);
}
